import React from "react";
import objectiveProductIcon from "../../assets/images/icons/ads-objective-product.svg";
import objectiveMarketplaceIcon from "../../assets/images/icons/ads-objective-marketplace.svg";

/* Only the 2 objectives that make sense once a product is already known (this flow always
   starts from a specific product's "Promote" button) - "Profile Visits" and "Go Live Promotion"
   target a profile/livestream instead, which this flow never has. */
const PROMOTE_OBJECTIVES = [
  {
    value: "product_listing_views",
    label: "Product Listing Views",
    description: "Show your product to more Shoppers and drive interest.",
    iconSrc: objectiveProductIcon,
  },
  {
    value: "marketplace_conversions",
    label: "Marketplace Conversions",
    description: "Get more purchases and add-to-card actions.",
    iconSrc: objectiveMarketplaceIcon,
  },
];

export default function PromoteObjective({ product, formData, updateFormData, onNext }) {
  const canContinue = formData.campaignName.trim() && formData.objective;
  const productImage = product?.product_media?.[0]?.url || "/image/default.png";

  return (
    <div>
      {/* Product being promoted - always known here, since this flow starts from its Promote button */}
      <div className="flex items-center gap-3 bg-[#fefdeb] border border-[rgba(195,197,217,0.6)] rounded-[22px] p-4 mb-6">
        <img src={productImage} alt={product?.product_name} className="w-12 h-12 rounded-lg object-cover shrink-0" />
        <div>
          <p className="text-[11px] font-bold text-[#095228] uppercase tracking-[0.5px]">Promoting</p>
          <p className="text-sm font-semibold text-[#131b2e]">{product?.product_name}</p>
        </div>
      </div>

      <label className="block text-sm font-semibold text-black mb-1">Campaign Name</label>
      <input
        type="text"
        value={formData.campaignName}
        onChange={(e) => updateFormData({ campaignName: e.target.value })}
        placeholder="Enter Campaign Name"
        className="w-full border border-[#c3c5d9] rounded-xl px-4 py-3 mb-6 text-sm"
      />

      <p className="text-sm font-semibold text-black capitalize">What's The Goal of this ad Campaign ?</p>
      <p className="text-xs text-[#747474] mt-1 mb-5">Choose the outcome you want to achieve with your ad.</p>

      <div className="space-y-4 mb-8">
        {PROMOTE_OBJECTIVES.map((obj) => {
          const selected = formData.objective === obj.value;
          return (
            <label
              key={obj.value}
              className={`flex items-center gap-4 bg-[#fefdeb] rounded-[22px] p-6 cursor-pointer ${
                selected
                  ? "border-2 border-[#1de78b] shadow-[0px_4px_20px_-4px_rgba(0,82,255,0.15)]"
                  : "border border-[rgba(195,197,217,0.6)] shadow-sm"
              }`}
            >
              <input
                type="radio"
                name="objective"
                checked={selected}
                onChange={() => updateFormData({ objective: obj.value })}
                className="sr-only"
              />
              <img src={obj.iconSrc} alt="" className="w-12 h-12 shrink-0" />
              <div className="flex-1">
                <p className="text-base font-semibold text-[#131b2e]">{obj.label}</p>
                <p className={`text-xs mt-0.5 ${selected ? "text-[#095228]" : "text-[#434656]"}`}>
                  {obj.description}
                </p>
              </div>
              <span
                className={`shrink-0 w-6 h-6 rounded-full ${
                  selected ? "bg-[#fefdeb] border-[6px] border-[#095228]" : "border-2 border-[#c3c5d9]"
                }`}
              />
            </label>
          );
        })}
      </div>

      <button
        type="button"
        disabled={!canContinue}
        onClick={onNext}
        className="bg-[#095228] border border-[#39b54a] text-[#f9e9ea] font-medium text-lg px-10 py-3 rounded-full shadow-[0_0_6px_rgba(59,182,76,0.53)] disabled:opacity-50"
      >
        Continue
      </button>
    </div>
  );
}
